import '../style/main.css';
import { useEffect, useState } from 'react';
import { getMovieList, searchMovie } from '../api';
import Hero from '../components/Hero';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import AutoAlertModal from '../components/AutoAlertModal';
import DescModal from '../components/DescModal';

const Utama = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [showModal, setShowModal] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);

  useEffect(() => {
    getMovieList().then((result) => {
      setPopularMovies(result);
    });
  }, []);

  const openDescriptionModal = (movie) => {
    setSelectedMovie(movie);
    setShowDescriptionModal(true);
  };

  const closeDescriptionModal = () => {
    setSelectedMovie(null);
    setShowDescriptionModal(false);
  };

  const PopularMovieList = () => {
    return popularMovies.map((movie, i) => {
      return (
        <div className="card bg-dark border border-warning border-3" style={{ width: '20rem' }}>
          <div className="tools ">
            <div className="circle">
              <span className="red box"></span>
            </div>
            <div className="circle">
              <span className="yellow box"></span>
            </div>
            <div className="circle">
              <span className="green box"></span>
            </div>
          </div>
          <div className="card__content ">
            <img className="Movie-image" src={`${process.env.REACT_APP_BASEIMGURL}/${movie.poster_path}`} />
            <div className="textBox text-white">
              <div className="Movie-title">{movie.title}</div>
              <div className="Movie-rate">Rate : {movie.vote_average}</div>
              <div className="Movie-date">Release Date : {movie.release_date}</div>
              <button className="btn btn-danger w-100" onClick={() => openDescriptionModal(movie)}>
                Description
              </button>
            </div>
          </div>
        </div>
      );
    });
  };

  const search = async (q) => {
    if (q.length === 0) {
      // Jika input pencarian kosong, kembalikan ke daftar film populer semula
      setShowModal(false); // Sembunyikan modal pencarian
      setSearchQuery(''); // Reset query pencarian
      getMovieList().then((result) => {
        setPopularMovies(result);
      });
    } else if (q.length > 3) {
      // Jika input pencarian lebih dari 3 karakter
      const query = await searchMovie(q);
      setShowModal(true); // Munculkan modal setiap kali melakukan pencarian
      setSearchQuery(q); // Simpan query pencarian untuk modal
      setPopularMovies(query.results);
    }
  };

  // console.log({ popularMovies: popularMovies });
  return (
    <div>
      <div className="App">
        {showModal && searchQuery.length > 3 && <AutoAlertModal closeModal={() => setShowModal(false)} />}
        <header className="App-header">
          <NavBar />
          <div className="waw">
            <Hero />
          </div>

          <span id="search" className="space">
            asdasd
          </span>
          <div sticky="top">
            <div className="d-flex">
              <h1>Cari Tontonan</h1> <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <input className="Movie-search" name="movieSearch" placeholder="The Avengers" onChange={({ target }) => search(target.value)} />
          </div>
          <div className="Movie-container">
            <PopularMovieList />
          </div>
          <Footer />
        </header>
      </div>
      <DescModal show={showDescriptionModal} handleClose={closeDescriptionModal} movie={selectedMovie} />
    </div>
  );
};

export default Utama;
